import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, hasOne, references } from '@apexdesigner/schema-tools';

export const interview = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    interviewDate: z
      .string()
      .nullable()
      .optional()
      .presentAs('date')
      .describe('Date the interview was conducted.'),

    candidateId: z.number().hidden().describe('Foreign key to Candidate'),

    interviewerId: z
      .number()
      .nullable()
      .optional()
      .hidden()
      .describe('Foreign key to User'),

    candidate: belongsTo('Candidate'),

    interviewer: references('User', 'interviewerId'),

    interviewMotivation: hasOne('InterviewMotivation', 'interviewId'),

    interviewTeamwork: hasOne('InterviewTeamwork', 'interviewId'),

    interviewProblemSolving: hasOne('InterviewProblemSolving', 'interviewId'),

    interviewStressResistance: hasOne(
      'InterviewStressResistance',
      'interviewId',
    ),

    interviewObservation: hasOne('InterviewObservation', 'interviewId'),
  })
  .describe('An interview session conducted for a candidate.')
  .as('Interview');

export { interview as interviewSchema };
